import moment from "moment"

export const FormatDateToString = (value: any, format: string = "DD/MM/YYYY HH:mm"): string => {
  const date = moment.parseZone(value).utc();
  return date.local().format(format);
}